import { render, staticRenderFns } from "./contato-emergencia.vue?vue&type=template&id=32151c5e"
import script from "./contato-emergencia.vue?vue&type=script&lang=js"
export * from "./contato-emergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports